import { render, staticRenderFns } from "./UserPass.vue?vue&type=template&id=3631b498&scoped=true"
import script from "./UserPass.vue?vue&type=script&lang=js"
export * from "./UserPass.vue?vue&type=script&lang=js"
import style0 from "./UserPass.vue?vue&type=style&index=0&id=3631b498&prod&scoped=true&lang=css"
import style1 from "./UserPass.vue?vue&type=style&index=1&id=3631b498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631b498",
  null
  
)

export default component.exports